import React from 'react';
import { useUser } from '@lore/auth';
import { PayloadStates } from '@lore/utils';
import queryString from 'query-string';
import { BeakerIcon } from '@heroicons/react/24/outline';
import OptionCard from '@/pages/my-network/OptionCard';
import useQuery from '@/pages/projects/useQuery';
import useUserTags from '@/hooks/useUserTags';
import TagTypes from '@/constants/TagTypes';
import Loader from '@/components/Loader';

export default function MatchingOffers() {
  const currentUser = useUser();

  const userSubjects = useUserTags(currentUser, TagTypes.Subject);

  const params = {
    search: {
      locationCondition: currentUser.data ? JSON.stringify({
        address: currentUser.data.zipCode,
        latitude: currentUser.data.latitude,
        longitude: currentUser.data.longitude,
        radius: 50
      }) : undefined,
      subjects: (userSubjects.data && userSubjects.data.length > 0) ?
        userSubjects.data.map(userSubject => userSubject.data?.tagId).filter(Boolean).join(',') :
        undefined
    }
  };

  const offers = useQuery(params);

  if (
    userSubjects.state === PayloadStates.FETCHING ||
    offers.state === PayloadStates.FETCHING
  ) {
    return (
      <Loader />
    );
  }

  if (
    userSubjects.meta?.totalCount === 0 ||
    offers.meta?.totalCount === 0
  ) {
    return null;
  }

  return (
    <OptionCard
      count={offers.meta?.totalCount}
      // imageUrl={bookshelfImage}
      icon={BeakerIcon}
      title="See offers that match your subject areas"
      subtitle="Community partners are offering exciting opportunities for learners in your area."
      linkText="View"
      to={{
        pathname: '/offers',
        search: queryString.stringify(params.search)
      }}
    />
  );
}
